import { useEffect, useState } from "react";
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom";
import useTrackedProperty from "../../../app/useTrackedProperty";

import './heartbeat.css';
import { arrayAny } from "../../../utils/arrayUtils";

export const HeartBeat = ({ heartBeat, getDisplayDate, getDuration }) => {

    const navigate = useNavigate();

    const [rerender, setRerender] = useState(false);
    const timeStamp = useTrackedProperty(heartBeat, "created"); 

    const updateStatuses = () => {

        const statusColour = () => {

            const now = moment().utc();
            const then = moment.utc(timeStamp);
            const diff = now.diff(then, 'seconds');

            if (diff < 5 * 60) { // less than 5 minute
                return "text-bright-green";
            } else if (diff < 10 * 60) { // less than 10 minutes
                return "text-orange";
            } else {
                return "text-red";
            }
        };

        heartBeat.icon = `fas fa-circle bg-transparent border-0 ${statusColour(timeStamp)} media-object-icon`;
        setRerender(!rerender);
    };

    const interval = setInterval(updateStatuses, 1000);

    useEffect(() => {
        return () => clearInterval(interval);
    });

    const handleLink = link => {

		const r = new RegExp("^(?:[a-z]+:)?//", "i");
		if (r.test(link.link)) {
			// URL is absolute
			window.open(link.link, link.target);
			return;
		} else {
			// URL is relative
			navigate(link.link);
			return;
		}
	};

    return (
        <div key={`heartbeat-${heartBeat.id}`} className="dropdown-item media">
            <div className="media-left">
                {heartBeat.imagePath ? <>
                    <img src={heartBeat.imagePath} className="media-object" alt=""></img>
                    <i className={`fa ${heartBeat.icon}`}></i>
                </>
                    :
                    <>
                        <i className={`fa ${heartBeat.icon} media-object bg-gray-500`}></i>
                    </>
                }

            </div>
            <div className="media-body">
                <h6 className="media-heading text-wrap mb-1">{heartBeat.topic} <i className={heartBeat.indicator}></i></h6>
                {arrayAny(heartBeat.links) && heartBeat.links.map((link, i) =>
                    <div key={`link-${i}`}>
                        <button className="btn btn-blue mb-1" title={link.description} onClick={() => { handleLink(link); }} >
                            <i title={link.displayText} className={link.target === "_blank" ? "fa fa-external-link" : "fa fa-arrow-right"}></i>&nbsp;&nbsp;{link.displayText}
                        </button>
                    </div>
                )}
                <div title={getDisplayDate(heartBeat.created)} className="text-muted fs-10px">{getDuration(heartBeat.created)} ago</div>
            </div>
        </div>
    );
}